module.exports = __webpack_public_path__ + "static/media/trophy_frame.7cc871cd.png";